$(() => {
    $('body').on('click', '.chb-tooltip-no-hover', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).toggleClass('open');

        const isOpen = $(this).hasClass('open');
        $(this).attr('aria-expanded', isOpen.toString());
    });

    // Prevent clicks on tooltip content from closing the tooltip
    $('body').on('click', '.chb-tooltip-no-hover .chb-tooltip-bubble', function(e) {
        e.stopPropagation();
    });

    $(document).on('click', function(e) {
        if (!$(e.target).closest('.chb-tooltip-no-hover').length) {
            $('.chb-tooltip-no-hover.open')
                .removeClass('open')
                .attr('aria-expanded', 'false');
        }
    });
});
